import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { Button } from '../ui/Button';
import { StepScreen } from './ActivationPrimitives';
import { MobileActivation } from '../../hooks/useMobileActivation';
import { getRule } from '../../data/mobileForwarding';

/** Final step after the user reports enabling forwarding. No network verification is claimed. */
export function ActivationReadyScreen({
  a,
  onHome,
  onPersonalize
}: {
  a: MobileActivation;
  onHome: () => void;
  onPersonalize?: () => void;
}) {
  const {
    isLight
  } = useTheme();
  const allCalls = a.mode === 'all';
  return <StepScreen stepKey="ready" footer={<>
          <Button fullWidth onClick={onHome} data-id="element-49" data-mp="1biwc2khzqk6">
            Go to Home
          </Button>
          {onPersonalize && <Button fullWidth variant="secondary" onClick={onPersonalize} data-id="element-50" data-mp="2lzng8ouz5reh">
              Personalize My AI
            </Button>}
        </>} data-id="element-48" data-mp="19odquwp8aj9">
      <div className="mb-6 mt-8 text-center" data-id="element-51" data-mp="3atbojzsdq8kt">
        <motion.div initial={{
        scale: 0.96,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className={`mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full ${isLight ? 'bg-vexu/10 text-vexu-700' : 'bg-vexu/20 text-vexu'}`} data-id="element-52" data-mp="3eunds47ccrsh">
          <ShieldCheck className="h-9 w-9" data-id="element-53" data-mp="2r39m80h0l08k" />
        </motion.div>
        <h1 className={`mb-3 text-2xl font-bold ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-54" data-mp="2vwb32e0s79us">Vexu is ready!</h1>
        <p className={`text-sm leading-relaxed ${isLight ? 'text-slate-600' : 'text-zinc-400'}`} data-id="element-55" data-mp="2i5631ati4fjx">
          With forwarding turned on, your assistant will answer your calls.
        </p>
      </div>
      <div className={`rounded-2xl border p-4 ${isLight ? 'border-vexu/20 bg-vexu/5' : 'border-vexu/20 bg-vexu/10'}`} data-id="element-56" data-mp="286zyelgb8vbd">
        <p className={`text-xs font-medium ${isLight ? 'text-slate-500' : 'text-zinc-400'}`} data-id="element-57" data-mp="2d6md6zbsejma">Answering mode</p>
        <p className={`mt-0.5 text-[15px] font-bold ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-58" data-mp="1p9gci4uim3my">
          {allCalls ? 'Answer every call' : "Only when you can't answer"}
        </p>
        {!allCalls && <ul className="mt-3 space-y-2" data-id="element-59" data-mp="1fbio9hcno6uc">
            {a.activeRules.map(r => <li key={r} className="flex items-center gap-2.5 text-sm" data-id="element-60" data-mp="2cz0twjb0ssu4">
                <CheckCircle2 className={`h-4 w-4 flex-shrink-0 ${isLight ? 'text-vexu-700' : 'text-vexu'}`} data-id="element-61" data-mp="2cy97nz3bc7gi" />
                <span className={`font-medium ${isLight ? 'text-slate-700' : 'text-zinc-200'}`} data-id="element-62" data-mp="27y3egeheacwb">{getRule(r).title}</span>
              </li>)}
          </ul>}
      </div>
    </StepScreen>;
}